import type { FaireProductEntity } from "../../entity_types/product";

export const p_77ny4b9n47: FaireProductEntity = {
  token: "p_77ny4b9n47",
  type: "product",
  name: "ID4348 Cotton Poplin Button-Front Pleated Midi Shirt Dress",
  brandToken: "b_4o95d3k7hq",
  brandName: "BUCKETLIST INC",
  imageUrl:
    "https://cdn.faire.com/fastly/c7b96b97fb3224fc0acfc2cd484ef6cc62410db4983a693d683d7feb363c8206.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f46221a95f01c3c729ddfdf0d7316d69496570212df825fd3675f6658bef622.jpeg",
    "https://cdn.faire.com/fastly/5ef535b0725e6fc0c36eddc4bced38124d19ad416364e0c40835c0d60f7e8830.jpeg",
    "https://cdn.faire.com/fastly/d5ecc77c5e7ac7d390316f15896057d00fc0a4b98ebedf4b7beaefbf4b6583b5.jpeg",
    "https://cdn.faire.com/fastly/64d8956bb55a8f716032c5778380d09b422fbf3a05060e2ed68bc687f8f644dd.jpeg",
    "https://cdn.faire.com/fastly/1cb077bf28973b684667d189b4d91a4a1561bafcd01e8304f693800c3b6d8d1f.jpeg",
    "https://cdn.faire.com/fastly/9dcbb8be0f94ea848670f86130844670178d075f41ff93c91aa200815e7bccbe.jpeg",
    "https://cdn.faire.com/fastly/b3b0450f4c29e8857b55c809c09318ea6578ef997e1ed0859a90775742be8705.jpeg",
    "https://cdn.faire.com/fastly/00477e4d04ce2a45730ea8407d9bb423e2cc047b4abce6991c23e457eb1940aa.jpeg",
    "https://cdn.faire.com/fastly/6e5471a9d7213c9c7fd4e8ae37cd5afa8470d3a95d770781da44a60384da8d15.jpeg",
    "https://cdn.faire.com/fastly/e51e6b2bf7c72ee4bd3f60e5f37566250a1ec772da45e5234e090a4a214f360f.jpeg",
    "https://cdn.faire.com/fastly/6018573ac87e59abca72eee24f69e400390b47be1ae14a1bf80b5874f8a6499a.jpeg",
    "https://cdn.faire.com/fastly/38dd58170ff20213c1d73ab4ba8e9972cc0ce43b0d467fc5869b0e09eef6018c.jpeg",
    "https://cdn.faire.com/fastly/cbb590effc993975270b4d67dc9c821ab409634c67db1278a249a23f16c3d4ac.jpeg",
    "https://cdn.faire.com/fastly/c7124c433cc8cbbd7619190e6f7b3643d3890878247b45b5bbb2c6d21ddf436c.jpeg",
    "https://cdn.faire.com/fastly/7bdf3ad05b0ffba7804e3c0ae1f41e019d48aba94c82df27e16bdc7d08d98005.jpeg",
    "https://cdn.faire.com/fastly/1d9eb571a572c847b4eebd7026d467a8ba55dda70961ddd3141b8bd94eadebee.jpeg",
  ],
  priceDollars: 28.95,
  description:
    "Cotton Poplin Button-Front Pleated Midi Shirt Dress\n• Waist-defining pleats.\n• Shirt collar\n• Exaggerated sleeves\n• Button closure at front\n• Side slant pockets",
  tags: [],
  msrpDollars: 57.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:01.769Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
